<template>
    <div class="modal-how-to" @click="clickClose($event)">
        <Transition name="slide-fade">
            <div role="dialog ff-text  text-a-gray-666666" v-if="isOpen" class="dialog">
                <div class="flex-auto min-h-0 w-full dialog-content overflow-y-auto">
                    <div class="main-blocks w-full h-full">
                        <div class="w-full text-center logo-bitkub">
                            <img class="mx-auto" src="@/module/Bitkub/assets/howto/bitkub-logo.svg" alt="" />
                        </div>
                        <div class="main-content text-center">
                            <div class="page-title">
                                <div class="ff-bold text-24 text-dark">How to get Wallet Address</div>
                                <div class="ff-bold text-20 text-orange">from Bitkub Next</div>
                            </div>
                            <div class="steps-container">
                                <div class="flex items-center min-w-0 step-1">
                                    <div class="flex-none relative">
                                        <img class="step-img"
                                            src="@/module/YesCoin/assets/howto/step-1-img/yc-step-1-img@2x.png" />
                                        <img src="@/module/YesCoin/assets/howto/yc-step-1-label.svg"
                                            class="absolute left-0 step-label horizontal-center" alt="" />
                                    </div>
                                    <div class="flex-auto ml-2 text-left">
                                        <div class="text-15 mb-2">
                                            <span class="ff-reg mr-1">เข้าไปที่เว็บไซต์</span> <span
                                                class="ff-bold text-orange">Bitkub NEXT </span>
                                        </div>
                                        <div>
                                            <BitkubNextUrl></BitkubNextUrl>
                                        </div>
                                        <div class="text-15 mt-2">
                                            <div class="ff-reg mr-1">และทำการเข้าสู่ระบบด้วย</div>
                                            <div>
                                                <span class="ff-bold text-orange">เบอร์โทรศัพท์มือถือ</span> หรือ <span
                                                    class="ff-bold text-orange">อีเมล</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <img class="img-guideline line-1" src="@/module/YesCoin/assets/howto/yc-line-1-2.svg" />
                                </div>
                                <div class="flex items-start min-w-0 step-2 flex-row-reverse">
                                    <div class="flex-none relative">
                                        <img class="step-img"
                                            src="@/module/YesCoin/assets/howto/step-2-img/yc-step-2-img@2x.png" />
                                        <img src="@/module/YesCoin/assets/howto/yc-step-2-label.svg"
                                            class="absolute left-0 step-label  horizontal-center" alt="" />
                                        <img src="@/module/YesCoin/assets/howto/step-2-bitkub-next/yc-pointer-2.png"
                                            class="absolute step-pointer" alt="" />
                                    </div>
                                    <div class="flex-auto text-right mr-4 ff-text text-a-gray-666666">
                                        <div class="mt-4 text-16 text-right">
                                            <div>
                                                คลิกที่ไอคอนแอปพลิเคชัน
                                            </div>
                                            <div class="text-orange ff-bold">
                                                Bitkub NEXT
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <img class="img-guideline line-1" src="@/module/YesCoin/assets/howto/yc-line-2-3.svg" />
                                </div>
                                <div class="flex items-center min-w-0 step-3">
                                    <div class="flex-none relative">
                                        <img class="step-img"
                                            src="@/module/YesCoin/assets/howto/step-3-img/yc-step-3-img@2x.png" />
                                        <img src="@/module/YesCoin/assets/howto/yc-step-3-label.svg"
                                            class="absolute left-0 step-label  horizontal-center" alt="" />
                                        <img src="@/module/YesCoin/assets/howto/step-3-ku/yc-pointer-3.png"
                                            class="absolute step-pointer" alt="" />
                                    </div>
                                    <div class="flex-auto ml-4 text-left ff-text text-a-gray-666666">
                                        <div class="mt-5 text-16 text-left">
                                            <div>
                                                คลิกที่ <span class="ff-bold text-orange">เบอร์โทรศัพท์มือถือ</span>
                                            </div>
                                            <div class="">
                                                หรือ <span class="ff-bold text-orange">อีเมล</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <img class="img-guideline line-1" src="@/module/YesCoin/assets/howto/yc-line-3-4.svg" />
                                </div>
                                <div class="flex items-start min-w-0 step-4 flex-row-reverse">
                                    <div class="flex-none relative">
                                        <img class="step-img"
                                            src="@/module/YesCoin/assets/howto/step-4-img/yc-step-4-img@2x.png" />
                                        <img src="@/module/YesCoin/assets/howto/yc-step-4-label.svg"
                                            class="absolute left-0 step-label  horizontal-center" alt="" />
                                        <img src="@/module/YesCoin/assets/howto/step-4-copy/yc-pointer-4.png"
                                            class="absolute step-pointer" alt="" />
                                    </div>
                                    <div class="flex-auto text-right mr-4 ff-text text-a-gray-666666">
                                        <div class="mt-3 text-16 text-right">
                                            <div>
                                                คลิกที่ <span class="ff-bold text-orange">ปุ่มคัดลอก</span> เพื่อรับ
                                            </div>
                                            <div>
                                                หมายเลข Wallet Address
                                            </div>
                                            <div>
                                                เป็นอันเสร็จสิ้น !
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="footer  ff-text text-a-gray-666666">
                            <div class="flex items-center min-w-0">
                                <div class="flex-none relative">
                                    <img class="img-footer"
                                        src="@/module/YesCoin/assets/howto/footer/yc-footer-screen.png" />
                                </div>
                                <div class="flex-auto ml-2 text-left text-dark">
                                    <div class="ff-bold text-18">สำหรับผู้ใช้งานที่ยังไม่มีบัญชี</div>
                                    <div class="ff-bold text-orange text-18 mb-3">
                                        Bitkub NEXT
                                    </div>
                                    <div class="text-13 mb-1">
                                        <div class="ff-bold mr-1">สามารถสร้างบัญชีได้ที่</div>
                                    </div>
                                    <div class="signup-box">
                                        <BitkubNextUrl></BitkubNextUrl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>

        <transition name="fade">
            <div class="modal-backdrop" v-if="isOpen"></div>
        </transition>
    </div>
</template>
<script>
import BitkubNextUrl from './components/BitkubNextUrl.vue';
export default {
    name: 'HowToModal',
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    components: {
        BitkubNextUrl
    },
    mixins: [],
    emits: [],
    data: function () {
        return {
            isOpen: false
        }
    },
    computed: {},
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    beforeUnmount: function () {
        this.busModal.off('show');
        this.busModal.off('hide');
    },
    methods: {
        show: function () {
            document.body.classList.add("not-scroll");
            this.isOpen = true
        },
        hide: function () {
            document.body.classList.remove("not-scroll");
            this.isOpen = false
        },
        clickClose: function (e) {
            // console.log(e.target)
            if (!e.target.classList.contains("bitkub-url")) {
                this.hide()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/YesCoin/style/base.scss";
@import "@/module/YesCoin/style/position.scss";
@import "./style/Dialog.scss";

$orange: #fd8103;
$dark: #313131;

.modal-how-to {
    @extend %base-class;

    //#region fade
    .fade-enter-active {
        transition: opacity 0.5s ease;
    }

    .fade-leave-active {
        opacity: 0;
        transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .slide-fade-leave-to {
        opacity: 0;
    }

    //#endregion fade

    //#region slide-face
    .slide-fade-enter-active {
        transition: all 0.3s ease-out;
    }

    .slide-fade-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
        transform: translatey(20px);
        opacity: 0;
    }

    //#endregion slide-face

    //#region utility

    .text-orange {
        color: $orange;
    }

    .text-bitkub {
        color: $bitkub;
    }

    .text-dark {
        color: $dark;
    }

    //#endregion
    .main-blocks {
        background-image: url("~@/module/YesCoin/assets/howto/yc-bg-header.svg"), url("~@/module/YesCoin/assets/howto/yc-header-curve.svg");
        background-position: center top, center top;
        background-repeat: no-repeat, no-repeat;

        .logo-bitkub {
            padding-top: 32px;
        }

        .main-content {
            left: 0px;
            width: 100%;
            padding: 8px;
            margin-top: -16px;

            .page-title {
                margin-bottom: 24px;
            }

            .steps-container {
                .img-guideline {
                    &.line-1 {
                        width: 100%;
                        padding: 0px 74px;
                        margin: -16px 0px -8px 0px;
                    }
                }

                .step-1 {
                    img.step-img {
                        max-width: 148px;
                    }

                    img.step-label {
                        bottom: -12px;
                    }
                }

                .step-2 {
                    img.step-img {
                        max-width: 148px;
                    }

                    img.step-label {
                        bottom: -12px;
                    }

                    img.step-pointer {
                        top: 100px;
                        left: -125px;
                        max-width: 167px;
                        max-height: 90px;
                    }
                }

                .step-3 {
                    img.step-img {
                        max-width: 148px;
                    }

                    img.step-label {
                        bottom: -12px;
                    }

                    img.step-pointer {
                        top: 36px;
                        right: -200px;
                        width: 285px;
                        max-width: 285px;
                    }
                }

                .step-4 {
                    img.step-img {
                        max-width: 148px;
                    }

                    img.step-label {
                        bottom: -12px;
                    }

                    img.step-pointer {
                        top: 93px;
                        left: -180px;
                        // width: 215.5px;
                        max-width: 215.5px;
                    }
                }

            }
        }

        .footer {
            padding: 16px 16px;
            background-size: cover;
            background-image: url("~@/module/YesCoin/assets/howto/yc-bg-footer.svg");
            background-position: center center;
            background-repeat: no-repeat;

            .img-footer {
                max-width: 110px;
            }

            .signup-box {
                margin-bottom: 50px;
            }
        }
    }
}
</style>
